/**
 * Тип монтажа форсунки по названию/описанию товара — держать в синхроне с
 * server/src/core/calculations/nozzles/mountType.js и NozzleSection.jsx
 * (тот же принцип дублирования, что у getProjectorColorType).
 * @param {Object} nozzle
 * @returns {'wall'|'bottom'|'vacuum'}
 */
export function getNozzleMountType(nozzle) {
    const text = `${nozzle?.name || ''} ${nozzle?.description || ''}`.toLowerCase();
    if (/пылесос/.test(text)) return 'vacuum';
    if (/донн|придонн/.test(text)) return 'bottom';
    return 'wall';
}
